import * as yup from 'yup';

export const formSchema = yup.object({
    trainer: yup.number().required(),
    amount: yup.number().required(),
    description: yup.string().required(),
});
